import { render } from "./accessibility-statement.vue?vue&type=template&id=266268be&scoped=true"
import script from "./accessibility-statement.vue?vue&type=script&lang=js"
export * from "./accessibility-statement.vue?vue&type=script&lang=js"

import "./accessibility-statement.vue?vue&type=style&index=0&id=266268be&lang=scss&scoped=true"

import exportComponent from "/srv/sites/eservice.talronbatt.co.il/api/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-266268be"]])

export default __exports__